export const getCroppedImg = (imageSrc, crop) => {
  return new Promise((resolve, reject) => {
    const image = new Image(); // Create a new Image instance
    image.src = imageSrc; // Set the source of the image
    image.onload = () => {
      const canvas = document.createElement("canvas"); // Create a canvas element
      const ctx = canvas.getContext("2d"); // Get the canvas context

      // Calculate the scaling factors based on the natural dimensions of the image
      const scaleX = image.naturalWidth / image.width;
      const scaleY = image.naturalHeight / image.height;

      // Set the canvas dimensions to match the cropped area
      canvas.width = crop.width;
      canvas.height = crop.height;

      // Draw the cropped portion of the image onto the canvas
      ctx.drawImage(
        image,
        crop.x * scaleX, // Start X position (scaled)
        crop.y * scaleY, // Start Y position (scaled)
        crop.width * scaleX, // Cropped width (scaled)
        crop.height * scaleY, // Cropped height (scaled)
        0,
        0,
        crop.width, // Output width
        crop.height // Output height
      );

      // Convert the canvas content to a Blob (image format)
      canvas.toBlob((blob) => {
        if (!blob) {
          reject(new Error("Canvas is empty")); // Handle empty canvas error
          return;
        }
        blob.name = "cropped.jpeg"; // Name the file
        resolve(URL.createObjectURL(blob)); // Create a URL for the Blob
      }, "image/jpeg"); // Set the output format
    };
    image.onerror = reject; // Handle errors during image loading
  });
};